import React from 'react';
import { SitemapCollection as SitemapCollectionType } from '../../../../types';
import SitemapItem from '../sitemap-items';
import * as S from './styles';

const SitemapCollection = ({ sitemapItems }: SitemapCollectionType) => {
  return (
    <S.SitemapItemList>
      {sitemapItems &&
        sitemapItems.map((item: any, index: number) => (
          <SitemapItem key={index} path={item.path} title={item.title} />
        ))}
    </S.SitemapItemList>
  );
};

export default SitemapCollection;
